import{e as n,t as m}from"./chunk-HAVQLHXJ.js";import{m as r}from"./chunk-HBP5N4FR.js";r();m();import{TokenPayment as e}from"@multiversx/sdk-core";function A(o,t=n){return e.fungibleFromAmount("",o,t).toString()}export{A as a};
//# sourceMappingURL=chunk-HOFMVQXK.js.map
